import React from "react";

type Props = {
  src: string;
  title?: string;
  subtitle?: string;
  /** Hauteur du héro */
  heightClass?: string; // ex: "h-[42vh] md:h-[50vh]"
  /** Position de cadrage : "50% 35%", "center top", etc. */
  focal?: string;
  /** Intensité du dégradé supérieur/inférieur (0..1) */
  overlayTop?: number;   // par défaut 0.25
  overlayBottom?: number; // par défaut 0.55
  /** Accessibilité */
  alt?: string;
  children?: React.ReactNode;
};

/**
 * Héro plein écran en "cover" (pas de bandes), avec point focal réglable.
 * -> Ajuste `focal` page par page : "50% 35%" (remonte un peu), "50% 60%" (descend), etc.
 */
export const PageHero: React.FC<Props> = ({
  src,
  title,
  subtitle,
  heightClass = "h-[42vh] md:h-[50vh]",
  focal = "50% 50%",
  overlayTop = 0.25,
  overlayBottom = 0.55,
  alt = "",
  children,
}) => {
  return (
    <section className={`relative w-full ${heightClass} overflow-hidden`}>
      <img
        src={src}
        alt={alt || title || ""}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ objectPosition: focal }}
        loading="eager"
      />
      {/* dégradé haut */}
      <div
        className="absolute inset-x-0 top-0 h-1/2 pointer-events-none"
        style={{
          background: `linear-gradient(to bottom, rgba(0,0,0,${overlayTop}), rgba(0,0,0,0))`,
        }}
      />
      {/* dégradé bas */}
      <div
        className="absolute inset-x-0 bottom-0 h-1/2 pointer-events-none"
        style={{
          background: `linear-gradient(to top, rgba(0,0,0,${overlayBottom}), rgba(0,0,0,0))`,
        }}
      />
      {/* contenu */}
      <div className="absolute inset-0 flex items-center justify-center text-center px-6">
        {children ? (
          children
        ) : title ? (
          <div className="text-white">
            <h1 className="text-3xl md:text-4xl font-bold">{title}</h1>
            {subtitle && (
              <p className="mt-2 text-white/90 text-base md:text-lg">{subtitle}</p>
            )}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default PageHero;
